import React from "react"
import PropTypes from "prop-types"

import { MAX_RATING } from "../static"

const puntos = Array.from({ length: MAX_RATING }, (unused, index) => index + 1)

const Estrellas = ({ value, className }) => (
  <div className={className}>
    {puntos.map(punto => (
      <span
        key={punto}
        className={`ped-star${value >= punto ? " is-on" : ""}`}
      >
        ★
      </span>
    ))}
  </div>
)

Estrellas.propTypes = {
  value: PropTypes.number,
  className: PropTypes.string.isRequired,
}

/** Bloque con etiqueta arriba, para la ficha del producto. */
export const StarsBig = ({ label, value }) => (
  <div className="ped-stars">
    <div className="ped-stars-label">{label}</div>
    <Estrellas value={value} className="ped-stars-row is-big" />
  </div>
)

StarsBig.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
}

/** Fila compacta con etiqueta a la izquierda, para la tabla de pedidos. */
export const StarsMini = ({ label, value }) => (
  <div className="ped-stars-mini">
    <span className="ped-stars-tag">{label}</span>
    <Estrellas value={value} className="ped-stars-row" />
  </div>
)

StarsMini.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
}
